import script from "./ModalDobError.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalDobError.vue?vue&type=script&setup=true&lang=js"

import "./ModalDobError.vue?vue&type=style&index=0&id=ee2688cc&lang=css"

const __exports__ = script;

export default __exports__